module.exports = __webpack_public_path__ + "static/img/10.a27cf89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/sp/10.png
// module id = 10Ts
// module chunks = 0